module.exports = __webpack_public_path__ + "static/media/movie-box.53c4b497.gif";